import { render } from "./WebProfileSkeleton.vue?vue&type=template&id=39e2f4ae&scoped=true"
import script from "./WebProfileSkeleton.vue?vue&type=script&lang=js"
export * from "./WebProfileSkeleton.vue?vue&type=script&lang=js"

import "./WebProfileSkeleton.vue?vue&type=style&index=0&id=39e2f4ae&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e2f4ae"]])

export default __exports__